import { leadCards } from "@/mocks/site";

export default function LeadFlash() {
  return (
    <section className="mx-auto max-w-[1400px] px-4 py-6 md:px-6">
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {leadCards.map((c) => (
          <a
            key={c.title}
            href="#timeline"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-1 hover:border-background-300"
          >
            <div className="relative h-44 w-full overflow-hidden bg-background-200 md:h-48">
              <img
                src={c.image}
                alt={`曝瓜网 ${c.channel} 实锤证据 ${c.title}`}
                title={`曝瓜网 ${c.channel} 截图流出 证据链 ${c.title}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="eyebrow absolute left-3 top-3 rounded-sm bg-background-950/70 px-2 py-1 text-[10px] font-bold text-background-50 backdrop-blur">
                {c.channel}
              </span>
            </div>
            <div className="flex flex-col p-4 md:p-5">
              <div className="flex items-center gap-2 text-[11px] text-foreground-500">
                <i className="ri-time-line" />
                {c.time}
                <span className="h-1 w-1 rounded-full bg-background-300" />
                <span className="font-medium text-primary-600">曝瓜网实锤跟进中</span>
              </div>
              <h3 className="clamp-2 mt-2 font-display text-base font-bold leading-snug text-foreground-950 md:text-lg">
                {c.title}
              </h3>
              <span className="mt-3 flex items-center gap-1 text-[13px] font-semibold text-primary-600 group-hover:text-primary-700">
                {c.linkLabel}
                <i className="ri-arrow-right-up-line transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}